// extracted by mini-css-extract-plugin
export default {"wrapper":"Title_wrapper__E+ld4","title":"Title_title__ugKfF"};